import { Calendar2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from './Button'
import { generatePath, useHistory } from 'react-router-dom'
import { useCallback } from 'react'
import { SCHEDULED_POSTS_PATH } from 'paths'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const CalendarButton = () => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()

  const goToCalendar = useCallback(() => {
    const path = generatePath(SCHEDULED_POSTS_PATH, { workspaceId: workspaceId })
    history.push(path)
  }, [history, workspaceId])

  return (
    <Button icon={Calendar2} aria-label="Calendar" onPress={goToCalendar}>
      <Text>Calendar</Text>
    </Button>
  )
}
